import React, { useEffect, useState } from 'react'
import crossImage from "../../assets/user/images/cross.png";
import { useSearchParams } from 'react-router-dom';

export default function Error() {
  const [message, setMessage] = useState('Error');
  const [params] = useSearchParams();
  useEffect(() => {
    try {
      const myMessage = atob(params.get('m'));
      setMessage(myMessage);
    } catch (err) {
      console.log("Invalid message");
    }
  }, []);
  return (
    <div>
      <div className="wraper-inner cpt bg-grey" style={{ height: "100vh" }}>
        <section className="inner-space space-b">
          <div className="container">
            <div className="row">
              <div className="col-md-6 m-auto thanku-card-main">
                <div className="dash-box-shadow pb-5">
                  <div className="thanku-card text-center mb-4 ">
                    <figure className="mb-3">
                      <img src={crossImage} alt="like" />
                    </figure>
                    <h3 className='pt-3'>{message}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}
